import type { Distance } from "@pdfking/math"
import { GetXY } from "@pdfking/math"

import type { Drawable } from "#internal"

import { CUT_COLOR_ID } from "../../../data/ColorList"
import { DistanceRound } from "../../../utils/DistanceRound"
import { GrowGuides } from "./GrowGuides"
import { PlotRectGuides } from "./PlotRectGuides"

/**
 * The cut inside the grow where it landed, a line along every page edge that
 * is neither a fold nor its outline: where the fill opened the grow up, the
 * room between its pages is cut away. The outline is cut by what holds the
 * grow, as one grid with its neighbours ({@link DrawCutLines}).
 */
export const DrawGrowCut: Drawable = node => {
  const grow = node.data?.grow
  if (!grow?.grow.show_cut) return []
  const landed = GrowGuides(node, grow)
  if (!landed) return []
  const { canvas, guides, folds } = landed
  const { x1, x2, y1, y2 } = GetXY(canvas)
  // Every page edge that is neither a fold nor the outline, from the canvas.
  const inner = (all: Distance[], fold: Distance[], low: Distance, high: Distance): Distance[] =>
    all
      .filter(v => ![...fold, low, high].some(f => DistanceRound(f) === DistanceRound(v)))
      .map(v => (v - low) as Distance)
  return [
    ...PlotRectGuides(
      canvas,
      { x: inner(guides.x, folds.x, x1, x2), y: inner(guides.y, folds.y, y1, y2) },
      CUT_COLOR_ID
    ),
  ]
}
